import { useEffect, useRef } from 'react'

// صحنهٔ زندهٔ هیرو — بازتابی از دنیای کار الهام:
// بادبزنِ سوآچ‌های ناخن (مثل عکس واقعی‌اش)، قطرهٔ لاک، خطِ براش و ستاره‌ها.
// اگر ویدیوی واقعی در public/videos/hero-nails.mp4 گذاشته شود، این ویدیو
// با پوشش هم‌رنگ سایت روی صحنه نشسته و جایگزین می‌شود.

interface HeroSceneProps {
  videoOk: boolean
  onVideoState: (playing: boolean) => void
  onVideoError: () => void
}

const SWATCH_SHADES = ['#f9d0c8', '#f4ab9d', '#ee8f92', '#ec806c', '#e56a9a', '#d94f7e', '#c73b6f']

const SwatchFan = () => (
  <svg viewBox="0 0 300 260" className="h-full w-full" fill="none" aria-hidden="true">
    {[-42, -28, -14, 0, 14, 28, 42].map((angle, i) => (
      <g key={i} transform={`rotate(${angle} 150 250)`}>
        <rect x="146" y="70" width="8" height="180" rx="4" fill="#f6e7d4" opacity="0.55" />
        {/* نوکِ لاک — طیف صورتی مثل عکس واقعی الهام */}
        <rect x="144.5" y="38" width="11" height="36" rx="5" fill={SWATCH_SHADES[i]} opacity="0.92" />
        <rect x="144.5" y="38" width="11" height="10" rx="5" fill="#ffffff" opacity="0.25" />
      </g>
    ))}
  </svg>
)

// ترکیب ساده‌شده: هر دو شاخه هم‌اکنون هم‌Modal را render می‌کنند، تنها فرق
// انیمیشن ورودی؛ این کار اشاره‌گرها و play() پایدار را آسان می‌کند.
const PlayingVideo = ({ ref }: { ref?: React.RefObject<HTMLVideoElement> }) => (
  <video
    ref={ref}
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    className="video-fade-in absolute inset-0 h-full w-full object-cover"
  >
    <source src="/videos/hero-nails.mp4" type="video/mp4" />
  </video>
)

const HeroScene = ({ onVideoState, onVideoError }: HeroSceneProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  // هر دو شاخه هم‌Modal هستند؛ یک راه‌اندازی مشترک برای پخش و گزارش
  const playVideo = (v: HTMLVideoElement | null) => {
    if (!v) return
    Promise.resolve(v.play()).catch(() => {})
  }

  useEffect(() => {
    // ویدیو فقط یک بار mount می‌شود؛ play روی همان رفرنس
    const v = videoRef.current
    if (!v) return
    playVideo(v)
    const onPlay = () => onVideoState(true)
    const onErr = () => onVideoError()
    v.addEventListener('playing', onPlay, { once: true })
    v.addEventListener('error', onErr, { once: true })
    return () => {
      v.removeEventListener('playing', onPlay)
      v.removeEventListener('error', onErr)
    }
  }, [])

  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* گرادیان رز — روشن‌تر و هم‌رنگ پالت جدید */}
      <div className="absolute inset-0 bg-[radial-gradient(130%_100%_at_75%_15%,#4a2430_0%,#33202b_40%,#1d141c_100%)]" />


      {/* بادبزن سوآچ — طیف صورتی، آرام می‌چرخد و نفس می‌کشد */}
      <div
        className="absolute -right-10 md:right-[8%] top-[16%] h-64 w-72 md:h-96 md:w-[28rem] opacity-80 md:opacity-90 animate-[sway_14s_ease-in-out_infinite_alternate]"
      >
        <div className="absolute inset-0 rounded-full bg-primary-400/15 blur-3xl" />
        <SwatchFan />
      </div>

      {/* قطرهٔ لاک شناور */}
      <div className="absolute left-[14%] top-[22%] h-10 w-10 rounded-full bg-primary-300/30 blur-[1px] animate-[bob_9s_ease-in-out_infinite]" />
      <div className="absolute left-[22%] bottom-[24%] h-5 w-5 rounded-full bg-secondary-300/25 animate-[bob_11s_ease-in-out_infinite_alternate]" />

      {/* خط براش — قوسی که آرام کشیده می‌شود */}
      <svg viewBox="0 0 600 200" className="absolute bottom-[10%] left-0 w-full opacity-25" fill="none" aria-hidden="true">
        <path
          d="M20 150 C 180 40, 420 40, 580 140"
          stroke="#f4ab9d"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="8 14"
          className="animate-[dashflow_18s_linear_infinite]"
        />
      </svg>

      {/* ستاره‌ها */}
      <span className="absolute right-[26%] top-[14%] h-1.5 w-1.5 rounded-full bg-secondary-200/70 animate-pulse" />
      <span className="absolute left-[30%] top-[34%] h-1 w-1 rounded-full bg-white/50 animate-pulse [animation-delay:1.2s]" />
      <span className="absolute right-[46%] bottom-[30%] h-1 w-1 rounded-full bg-primary-200/60 animate-pulse [animation-delay:2s]" />

      {/* ویدیوی واقعی — وقتی موجود و در حال پخش باشد، روی صحنه با پوشش هم‌رنگ sit می‌شود.
          یک رفرنس مشترک → همیشه پخش می‌شود، حتی وقتی اول pinning نشده. */}
      <PlayingVideo ref={videoRef} />
      {/* پوشش هم‌رنگ پالت — ویدیو همیشه با هویت سایت دیده می‌شود */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#4a2430]/45 via-[#33202b]/35 to-[#1d141c]/80 mix-blend-multiply" />
    </div>
  )
}

export default HeroScene
